import styled from 'styled-components';

import LoadingIndicator from 'dashboard/components-lib/LoadingIndicator';
import { Z_INDICES } from 'dashboard/styles/variables';

/**
 * Dashboard full screen loading spinner.
 * TODO: Move to dashboard/components/*
 */
const StyledLoadingIndicator = styled(LoadingIndicator)`
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: rgba(255, 255, 255, 0.75);
  z-index: ${Z_INDICES.withShadow};
  border-radius: inherit; /* so it doesn't spill out of container */
`;

const LoadingOverlay = () => <StyledLoadingIndicator delayed={false} />;

export default LoadingOverlay;
